export default ({ searchInputId }) => {
  global.$(`#${searchInputId}`).val('');
};
